import { useCallback, useRef, useState } from "react";

export const useTopicsSearch = () => {
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const resetSearchInput = useCallback(() => {
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    setSearchQuery("");
  }, []);

  return {
    searchQuery,
    setSearchQuery,
    resetSearchInput,
    searchInputRef,
  };
};
